export default __webpack_public_path__ + "5abca6be01d830aca63263468824ab9b.png";